import React, { useContext, useState } from 'react';

import SocialAuthButton from './SocialAuthButton';
import { SocialAuthBoxWrapper } from './SocialAuthBox.styled';
import AuthContext from '@context/AuthContext';
import Button from '@components/atoms/button/Button';
import String from '@components/atoms/string/String';
import {
  ErrorLink,
  ErrorMsg,
} from '../logInBox/userLogInForm/UserLogInForm.styled';
import { authenticateWithPopup } from '@src/utils/authHelper';
import Svg from '@components/atoms/svg/Svg';

const SocialAuthBox = props => {
  const authContext = useContext(AuthContext);

  const [logInFormState, setLogInFormState] = useState({
    isLoading: false,
    isAuthError: false,
    isErrorMsg: '',
  });

  const handleFailure = message => {
    setLogInFormState({
      ...logInFormState,
      isLoading: false,
      isAuthError: true,
      isErrorMsg: message,
    });
  };

  const handleAuthSuccess = () => {
    setLogInFormState({
      ...logInFormState,
      isLoading: false,
      isAuthError: false,
    });
  };

  const handleSuccess = data => {
    const loginData = {
      token: data.token,
      successCallback: handleAuthSuccess,
    };
    authContext.socialAuth(loginData);
  };

  const handleOnClick = () => {
    setLogInFormState({
      ...logInFormState,
      isLoading: true,
    });
  };

  const googleRedirectUri = `${API_URL}/login-external/adsk`;
  const appleRedirectUri = `${API_URL}/login-external/apple`;
  const adskRedirectUri = `${API_URL}/login-external/adsk`;

  const googleClientId =
    '67450846701-o6jhauclqfvnsefhp37cu8c9qt24vcet.apps.googleusercontent.com';

  const adskClientId = 'PFRAwXW96hBNYGvmSLMITG56GFnISnKRSHC9XAeW9QsB7LpU';

  const getLabel = () => {
    switch (props.type) {
      case 'signup':
        return {
          google: 'sign_up_google_button_label',
          apple: 'sign_up_apple_button_label',
          linkedin: 'sign_up_linkedin_button_label',
          adsk: 'sign_up_adsk_button_label',
        };

      case 'signin':
        return {
          google: 'sign_in_google_button_label',
          apple: 'sign_in_apple_button_label',
          linkedin: 'sign_in_linkedin_button_label',
          adsk: 'sign_in_adsk_button_label',
        };

      default:
        break;
    }
  };

  const handleAdskLogin = async () => {
    const token = await authenticateWithPopup();
    if (token && token.length > 0) {
      window.location.replace(
        `${API_URL}/login-external/adsk?code=${token}&provider=adsk`
      );
    }
  };

  return (
    <>
      <SocialAuthBoxWrapper>
        <Button
          type="normal"
          label="Sign in with Autodesk"
          colorTheme="adsk"
          onClick={handleAdskLogin}
          actionType="onclick"
          svgIcon={'adsk'}
          css={{ marginBottom: '$8', width: '100%' }}
        />
        {/* {props.type === 'signup' && (
          <div
            style={{
              display: 'flex',
              padding: '16px',
              borderRadius: '8px',
              // padding: '2px 1rem',
              backgroundColor: 'rgb(95, 96, 255)',
              color: '#FFF',
            }}
          >
            <div>
              {' '}
              <Svg
                icon={'warning'}
                css={{
                  fill: '$white',
                  height: '$32',
                  width: '$32',
                  marginRight: '$12',
                }}
              />
            </div>
            AREA is undergoing scheduled maintenance. Some features will be
            temporarily disabled. Sorry for the inconvenience and thank you for
            your understanding!
          </div>
        )} */}

        {props.type !== 'signup' && (
          <>
            <SocialAuthButton
              onFailure={handleFailure}
              onSuccess={handleSuccess}
              redirectUri={googleRedirectUri}
              label={<String id={`${getLabel().google}`} />}
              provider="google"
              clientId={googleClientId}
              scope=""
              onClick={handleOnClick}
            />
            <SocialAuthButton
              onFailure={handleFailure}
              onSuccess={handleSuccess}
              redirectUri={appleRedirectUri}
              label={<String id={`${getLabel().apple}`} />}
              provider="apple"
              scope=""
              onClick={handleOnClick}
            />
          </>
        )}
        {logInFormState?.isAuthError && (
          <ErrorMsg>
            Sorry, we couldn't find any AREA account with that email, please use
            a different email or{' '}
            <ErrorLink to="/join">create a new account</ErrorLink>
          </ErrorMsg>
        )}
      </SocialAuthBoxWrapper>
    </>
  );
};

export default SocialAuthBox;
